import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import formatData, { formatMnDate } from "@mnjsplatform/data/lib/utils/formatData";
import MnComboInlineEnum from "@mnjsplatform/components/lib/common/Dropdown/MnComboInlineEnum";
import DocumentStatusImage from "@mnjsplatform/components/lib/common/DocumentStatusImage";
import { initSubgrid, unmountSubgrid } from "@mnjsplatform/data/lib/actions/subgridActions";
import SubgridPlaceholder from "@mnjsplatform/components/lib/common/Subgrid/SubgridPlaceholder";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import PopupWrapper from "@mnjsplatform/components/lib/common/PopupWrapper";
import i18next from "i18next";
import {workplaceCountries} from "../../actions/AppActions";
import WaybillForm from "../SubComponents/WaybillForm";

class TransportReqCard extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      subGridExpanded: false,
      subGridKey: null,
      isExpanded: false,
      routeDetailsWindowOpened: false,
      elapsedAfterTimerUpdate: 0,
      isWaybillFormVisible: false
    };

    this.countdownTimerId = null;
  }

  componentWillUnmount() {

    if(this.state.subGridKey)
      this.props.dispatch(unmountSubgrid(this.props.dataItem, this.state.subGridKey));

    this.resetCountdownTimer();
  }

  componentDidMount() {
    this.startCountdownTimer();
  }

  componentWillUpdate(nextProps, nextState, nextContext) {

    if(!nextProps.row || !this.props.row || nextProps.row.AcceptDurationSec !== this.props.row.AcceptDurationSec) {
      nextState.elapsedAfterTimerUpdate = 0;
      this.resetCountdownTimer();
    }

    if(nextProps.showMode !== this.props.showMode) {
      nextState.isExpanded = false;
    }

    if(nextProps.row !== this.props.row && this.state.subGridExpanded) {
      nextState.subGridExpanded = false;
      this.closeSubgrid();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    if(this.props.row && (!prevProps.row || this.props.row.AcceptDurationSec !== prevProps.row.AcceptDurationSec)) {
      this.startCountdownTimer();
    }
  }

  resetCountdownTimer = () => {
    if(this.countdownTimerId != null) {
      clearTimeout(this.countdownTimerId);
      this.countdownTimerId = null;
    }
  };

  startCountdownTimer = (timeout) => {
    this.countdownTimerId = setTimeout(this.onCountdownTimerTick, timeout > 0 ? timeout : 20000);
  };

  onCountdownTimerTick = () => {

    if(!this.props.row || !this.props.row.AcceptDurationSec || this.props.row.AcceptDurationSec < 0) {
      return;
    }

    let acceptDuration = parseInt(this.props.row.AcceptDurationSec, 10);
    let newElapsedAfterTimerUpdate = this.state.elapsedAfterTimerUpdate + 20;

    if(acceptDuration && acceptDuration > 0 && acceptDuration - newElapsedAfterTimerUpdate > 0) {
      let timeout = Math.min(60000, (acceptDuration - newElapsedAfterTimerUpdate + 1) * 1000);
      this.startCountdownTimer(timeout);
    }

    this.setState({ elapsedAfterTimerUpdate: newElapsedAfterTimerUpdate});
  };

  onRowToggle = (rowIndex) => {
    let isExpanded = this.state.isExpanded;
    this.setState({isExpanded: !isExpanded});
  };

  onShowRouteDetails = () => {

    this.setState({routeDetailsWindowOpened: true});

    let params = {IsOnlyTotal: 0};

    Object.assign(params, this.props.dataItem.getRow(this.props.rowIndex));

    this.props.dispatch(this.props.routeDetailsItem.reset())
      .then(() => {this.props.dispatch(this.props.routeDetailsItem.execute(params, {newItem: true}))});
  };

  onCloseRouteDetails = () => {
    this.setState({routeDetailsWindowOpened: false});
  };

  onShowSubGrid = (rowIndex) => {
    let isSubGridExpanded = this.state.subGridExpanded;

    this.setState({ subGridExpanded: !isSubGridExpanded});

    if(isSubGridExpanded)
      this.closeSubgrid(rowIndex);
    else
      this.initRouteSubgrid(rowIndex);
  };

  initRouteSubgrid = (rowIndex) => {
    this.props.dispatch(initSubgrid(this.props.dataItem, this.props.routeSubGridColumnName, rowIndex, "", true))
      .then(key => {
        if(this.state.subGridExpanded)
          this.setState({ subGridKey: key});
        else
          this.props.dispatch(unmountSubgrid(this.props.dataItem, key))
      });
  };

  closeSubgrid = () => {

    if(this.state.subGridKey)
      this.props.dispatch(unmountSubgrid(this.props.dataItem, this.state.subGridKey))
        .then(() => {
          this.setState({ subGridKey: null});
        });
  };

  renderRouteDetailsWindow = () => {
    if(!this.state.routeDetailsWindowOpened)
      return null;

    return (
      <PopupWrapper onClose={this.onCloseRouteDetails} popupVisible={this.state.routeDetailsWindowOpened} title={i18next.t("InfoAboutLinkedDocuments")}>
        <GridView dataItem={this.props.routeDetailsItem} readOnly/>
      </PopupWrapper>
    );
  };

  renderRouteSubgridRow = (row, rowIndex, renderRowDefault, dataItem) => {

    let fiMap = {};

    dataItem.rawData.ResultFieldInfo.forEach((item) => {fiMap[item.Name] = item;});

    let loadOrder = formatData(fiMap["LoadOrder"], row.LoadOrder);

    if(loadOrder)
      loadOrder += ". ";
    else
      loadOrder = "";

    let clientName = formatData(fiMap["Receiver"], row.Receiver);

    let weight = formatData(fiMap["Weight"], row.Weight);

    if(weight && weight.length > 0)
      weight = "    " + fiMap.Weight.Title + ": " + weight;
    else
      weight = "";

    let deliveryPeriod = null;
    const isUkr = this.props.workplaceCountry === workplaceCountries.UKR;

    if(row.DTOrderDay || row.DTOrderTimeMin || row.DTOrderTimeMax)
      deliveryPeriod = i18next.t(`TransportReqCard_DeliveryPeriod${isUkr ? "_Ukr" : ""}`, {
        date: row.DTOrderDay != null ? formatMnDate(row.DTOrderDay) + " " : "",
        minTime: formatMnDate(row.DTOrderTimeMin),
        maxTime: formatMnDate(row.DTOrderTimeMax)
      });

    return (
       <React.Fragment>
         <div className="row fs15">
           <div className="column col-md-12" style={{backgroundColor: "white", height: "1px"}}/>
         </div>
         {row.Shipper &&
             <div className="row fs15">
               <div className="column col-md-12" style={{backgroundColor: "green"}}>
               <span style={{color: "white"}}>{row.Shipper}</span>
               </div>
             </div>
         }
         {row.SrcPointName &&
             <div className="row fs15">
               <div className="column col-md-12" style={{backgroundColor: "green"}}>
                 <span style={{color: "white"}}>{row.SrcPointName}</span>
               </div>
             </div>
         }
          <div className="row fs15">
            <div className="column col-md-12" style={{backgroundColor: "green"}}>
              <span style={{color: "white"}}>{loadOrder}{clientName}</span>
              <span style={{ color: "white", marginLeft: "5px", fontWeight: "bold" }}>{weight}</span>
            </div>
          </div>
         <div className="row fs15">
           <div className="column col-md-12" style={{backgroundColor: "green"}}>
             <span style={{color: "white"}}>{row.DstPointName}</span>
           </div>
         </div>
         {deliveryPeriod &&
           <div className="row fs15">
             <div className="column col-md-12" style={{ backgroundColor: "green" }}>
               <span style={{ color: "white" }}>{deliveryPeriod}</span>
             </div>
           </div>
         }
       </React.Fragment>
    );
    // return (
    //   <React.Fragment>
    //     <div className="row fs15">
    //       <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px", marginTop: "1px"}}>
    //         <span className="field-title fs13" style={{color: "white"}}>{fiMap.DocumentTypeName.Title}</span>
    //         <span style={{color: "white"}}>&nbsp;{row.DocumentTypeName}</span>
    //       </div>
    //     </div>
    //     <div className="row fs15">
    //       <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px"}}>
    //         <span className="field-title fs13" style={{color: "white"}}>Номер документа:</span>
    //         <span style={{color: "white"}}>&nbsp;{documentDescription}</span>
    //       </div>
    //     </div>
    //     <div className="row fs15">
    //       <div className="column col-md-6" style={{backgroundColor: "green", paddingTop: "5px"}}>
    //         <span className="field-title fs13" style={{color: "white"}}>{fiMap.Weight.Title}</span>
    //         <span style={{color: "white"}}>&nbsp;{formatData(fiMap["Weight"], row.Weight)}</span>
    //       </div>
    //       <div className="column col-md-6" style={{backgroundColor: "green", paddingTop: "5px"}}>
    //         <span className="field-title fs13" style={{color: "white"}}>{fiMap.GrossCost.Title}</span>
    //         <span style={{color: "white"}}>&nbsp;{formatData(fiMap["GrossCost"], row.GrossCost)}</span>
    //       </div>
    //     </div>
    //     <div className="row fs15">
    //       <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px"}}>
    //         <span className="field-title fs13" style={{color: "white"}}>{fiMap.SrcPointName.Title}</span>
    //         <span style={{color: "white"}}>&nbsp;{row.SrcPointName}</span>
    //       </div>
    //     </div>
    //     <div className="row fs15">
    //       <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px"}}>
    //         <span className="field-title fs13" style={{color: "white"}}>{fiMap.DstPointName.Title}</span>
    //         <span style={{color: "white"}}>&nbsp;{row.DstPointName}</span>
    //       </div>
    //     </div>
    //     <div className="row fs15">
    //       <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px"}}>
    //         <span className="field-title fs13" style={{color: "white"}}>{fiMap.Receiver.Title}</span>
    //         <span style={{color: "white"}}>&nbsp;{row.Receiver}</span>
    //       </div>
    //     </div>
    //     <div className="row fs15">
    //       <div className="column col-md-12" style={{backgroundColor: "green", paddingTop: "5px"}}>
    //         <span className="field-title fs13" style={{color: "white"}}>Плановая доставка:</span>
    //         <span style={{color: "white"}}>&nbsp;{deliveryPeriod}</span>
    //       </div>
    //     </div>
    //   </React.Fragment>
    // );
  };

  renderRouteSubgrid = () => {

    if(!this.state.subGridKey)
      return (
        <div className="row fs15">
          <div className="column col-md-12" style={{backgroundColor: "green", textAlign: "center", paddingTop: "5px", paddingBottom: "5px"}}>
            <span style={{color: "white"}}>{i18next.t("LoadingLabel")}</span>
          </div>
        </div>
      );

    return (
      <SubgridPlaceholder subgridKey={this.state.subGridKey}>
        {(subgridItem) => {

          if(subgridItem.rowsCount() === 0)
            return (
              <div className="row fs15">
                <div className="column col-md-12" style={{backgroundColor: "green", textAlign: "center", paddingTop: "15px", paddingBottom: "15px"}}>
                  <span style={{color: "white"}}>{i18next.t("GridViewEmptyLabel")}</span>
                </div>
              </div>
            );
          else
            return (
              <GridView dataItem={subgridItem}
                        readOnly
                        renderRow={this.renderRouteSubgridRow}
                        showHeader={false}
                        allowHorizontalScrolling={false}
              />
            );
        }
        }
      </SubgridPlaceholder>
    );
  };

  showWaybillForm = (e) => {
    this.setState({isWaybillFormVisible: true});
  };

  onCloseWaybillForm = () => {
    this.setState({isWaybillFormVisible: false});
  };

  onSaveWaybillForm = () => {
    this.props.onCardDataChanged();
    this.onCloseWaybillForm();
  };

  renderWaybillForm = () => {
    if (!this.state.isWaybillFormVisible) {
      return null;
    }

    return (
      <WaybillForm row={this.props.row}
                   onSave={this.onSaveWaybillForm}
                   onClose={this.onCloseWaybillForm}
                   getBufferData={this.props.getBufferData}
      />
    );
  };

  renderCommandButtons = (row, rowIndex) => {

    let self = this;

    const isRus = this.props.workplaceCountry === workplaceCountries.RUS;

    const allowAccept = row.AllowAccept === 1;//true;
    const allowRefuse = row.AllowRefuse === 1;//true;
    const allowEdit = row.AllowEdit === 1;//true;
    const allowTLEdit = row.AllowTLEdit === 1 && isRus;//true;
    const allowFill = row.AllowFill === 1;
    const allowCopy = row.AllowCopy === 1;// && isRus;

    const allowGPSEdit = row["AllowGPSEdit"] === 1 && isRus;
    const isGPSFilled = !!row["GPSId"] || !!row["GPSPhoneId"];
    const editGPSTitle = isGPSFilled ? i18next.t("EditTrackingButton") : i18next.t("SetupTrackingButton");
    const editGPSClassName = `btn btn-regular btn-carrier-action ${isGPSFilled ? "godefault" : "-goescape"}`;

    const allowFillWaybill = row["AllowSWEdit"] === 1 && isRus;
    const isWaybillFilled = !!row["SWTransportationTypeId"];
    const fillWaybillTitle = isWaybillFilled ? i18next.t("EditWaybillButton") : i18next.t("FillWaybillButton");
    const fillWaybillClassName = `btn btn-regular btn-carrier-action ${isWaybillFilled ? "-godefault" : "-goescape"} ${!!row.IsCustETRN ? "-warning" : ""}`;

    let isExistsFieldForCopy = row.Fields2Copy != null;

    let buttonContainerStyle = {};

    if(this.props.showMode === 0)
      buttonContainerStyle.marginTop = "5px";

    return (
      <div className="row fs15" style={buttonContainerStyle}>
        <div className="column col-md-12">
          {allowRefuse &&
          <button type="button" className="btn btn-regular btn-carrier-action btn-trc-action -goback" style={{marginTop: "5px", marginBottom: "10px", minWidth: "105px"}}
                  onClick={() => {if(self.props.onRefuseTransportReq) self.props.onRefuseTransportReq(row, rowIndex)}}>
            {i18next.t("RefusalButton")}
          </button>
          }
          {allowAccept &&
          <button type="button" className="btn btn-regular btn-carrier-action btn-trc-action -goahead" style={{marginTop: "5px", marginBottom: "10px"}}
                  onClick={() => {if(self.props.onAcceptTransportReq) self.props.onAcceptTransportReq(row, rowIndex)}}>
            {i18next.t("AcceptButton")}
          </button>
          }
          {!allowFill && allowEdit &&
          <button type="button" className="btn btn-regular btn-carrier-action -godefault" style={{marginTop: "5px", marginBottom: "10px"}}
                  onClick={() => {if(self.props.onEditTransportReq) self.props.onEditTransportReq(row, rowIndex)}}>
            {i18next.t("ChangeButton")}
          </button>
          }
          {allowFill &&
          <button type="button" className="btn btn-regular btn-carrier-action -goescape" style={{marginTop: "5px", marginBottom: "10px"}}
                  onClick={() => {if(self.props.onEditTransportReq) self.props.onEditTransportReq(row, rowIndex)}}>
            {i18next.t("EnterDataButton")}
          </button>
          }
          {allowCopy && isExistsFieldForCopy &&
          <button type="button" className="btn btn-regular btn-carrier-action -godefault" style={{marginTop: "5px", marginBottom: "10px"}}
                  onClick={() => {if(self.props.onEditTransportReq) self.props.onSaveDataForCopy(row, rowIndex)}}>
            {i18next.t("CopyRequisitesButton")}
          </button>
          }
          {allowTLEdit &&
          <button type="button" className="btn btn-regular btn-carrier-action -goescape" style={{marginTop: "5px", marginBottom: "10px"}}
                  onClick={() => {if(self.props.onCreateTL) self.props.onCreateTL(row, rowIndex)}}>
            {i18next.t("CreatePowerOfAttorney")}
          </button>
          }
          {allowGPSEdit &&
          <button type="button" className={editGPSClassName} style={{marginTop: "5px", marginBottom: "10px"}}
                  onClick={() => {if(self.props.onGPSEdit) self.props.onGPSEdit(row, rowIndex)}}>
            {editGPSTitle}
          </button>
          }
          {allowFillWaybill &&
          <button type="button" className={fillWaybillClassName} style={{marginTop: "5px", marginBottom: "10px"}}
                  onClick={this.showWaybillForm}>
            {fillWaybillTitle}
          </button>
          }
        </div>
      </div>
    )
  };

  renderFieldRow = (fiMap, row, name, specialData) => {
    const data = typeof specialData !== 'undefined' ? specialData : row[name];
    return (
      <div className="row fs15">
        <div className="column col-md-12">
          <span className="field-title">{fiMap[name].Title}</span>
          <span>&nbsp;{data}</span>
        </div>
      </div>
    );
  };

  renderFieldRowIfExists = (fiMap, row, name, specialData) => {
    if (!row[name]) {
      return null;
    }
    return this.renderFieldRow(fiMap, row, name, specialData);
  };

  renderAdditionalRowData = (fiMap, row, rowIndex) => {

    if(this.props.showMode < 2 && !this.state.isExpanded)
      return null;

    return (
      <div style={{marginTop: "5px"}}>
        {this.props.workplaceCountry === workplaceCountries.RUS &&
        <>
          {this.renderFieldRow(fiMap, row, "AutoNumber")}
          {this.renderFieldRow(fiMap, row, "DrivingLicence")}
          {this.renderFieldRow(fiMap, row, "PhoneNumber")}
          {this.renderFieldRow(fiMap, row, "TrustNumber")}
          {this.renderFieldRow(fiMap, row, "TrustDate", formatMnDate(row.TrustDate))}
          {this.renderFieldRow(fiMap, row, "TransportCompanyComment")}
          {this.renderFieldRow(fiMap, row, "AssignDateTime", formatMnDate(row.AssignDateTime))}
          {this.renderFieldRowIfExists(fiMap, row, "OfferBeginLoadTime", formatMnDate(row.OfferBeginLoadTime))}
          {this.renderFieldRow(fiMap, row, "IsAccept", row.IsAccept === 1 ? i18next.t("Yes") : i18next.t("No"))}
          {this.renderFieldRowIfExists(fiMap, row, "GPSName")}
          {this.renderFieldRowIfExists(fiMap, row, "GPSPhoneId")}
          {this.renderFieldRow(fiMap, row, "SWDriverTaxCode")}
          {this.renderFieldRowIfExists(fiMap, row, "SWTransportationTypeName")}
          {this.renderFieldRowIfExists(fiMap, row, "SWTruckOwnTypeName")}
          {this.renderFieldRowIfExists(fiMap, row, "SWContractSignedName")}
          {this.renderFieldRowIfExists(fiMap, row, "SWTruckOwnName")}
          {this.renderFieldRowIfExists(fiMap, row, "SWTruckOwnTaxCode")}
          {this.renderFieldRowIfExists(fiMap, row, "SWTruckOwnLegalAddress")}
          <div className="row fs15">
            <div className="column col-md-12">
              <span>{row.TLSName}</span>
            </div>
          </div>
        </>
        }
        {this.props.workplaceCountry === workplaceCountries.UKR &&
        <>
          {this.renderFieldRow(fiMap, row, "DrivingLicence")}
          {this.renderFieldRow(fiMap, row, "PhoneNumber")}
          {this.renderFieldRow(fiMap, row, "AddAutoTruckCompany")}
          {this.renderFieldRowIfExists(fiMap, row, "AutoNumber")}
          {this.renderFieldRow(fiMap, row, "AutoAdd1")}
          {this.renderFieldRow(fiMap, row, "TransportCompanyComment")}
        </>
        }
      </div>
    );
  };

  renderOptimalModeData = (fiMap, row, rowIndex) => {

    if(this.props.showMode === 0 && !this.state.isExpanded)
      return null;

    const isRus = this.props.workplaceCountry === workplaceCountries.RUS;
    const isUkr = this.props.workplaceCountry === workplaceCountries.UKR;

    if (isRus) {
      return (
        <>
          <div className="row fs15">
            <div className="column col-md-6">
              <span className="field-title">{fiMap.PlanGrossWeight.Title}</span>
              <span>&nbsp;{formatData(fiMap["PlanGrossWeight"], row.PlanGrossWeight)}</span>
            </div>
            <div className="column col-md-6">
              <span className="field-title">{fiMap.PlanCostLoad.Title}</span>
              <span>&nbsp;{formatData(fiMap["PlanCostLoad"], row.PlanCostLoad)}</span>
            </div>
          </div>
          <div className="row fs15">
            <div className="column col-md-6">
              <span className="field-title">{fiMap["AddPlanBeginLoadTime"].Title}</span>
              <span>&nbsp;{formatMnDate(row["AddPlanBeginLoadTime"])}</span>
            </div>
            <div className="column col-md-6">
              <span className="field-title">{fiMap["TotalGrossCost"].Title}</span>
              <span>&nbsp;{formatData(fiMap["TotalGrossCost"], row.TotalGrossCost)}</span>
            </div>
          </div>
          {row.IsComplex === 1 &&
          <div className="row fs15">
            <div className="column col-md-8">
              <span style={{ color: "red", fontWeight: 'bold' }}>{i18next.t("ComplexRequirement")}</span>
            </div>
          </div>
          }
          {row["UnloadTime"] &&
              <div className="row fs15">
                <div className="column col-md-12">
                  <span className="field-title">{fiMap["UnloadTime"].Title}</span>
                  <span>&nbsp;{formatMnDate(row["UnloadTime"])}</span>
                </div>
              </div>
          }
          {this.renderFieldRow(fiMap, row, "AutoDriver")}
          {row.Subject != null && this.renderFieldRow(fiMap, row, "Subject")}
        </>
      );
    }

    if (isUkr) {
      return (
        <>
          {this.renderFieldRow(fiMap, row, "GrossWeight", formatData(fiMap["GrossWeight"], row.GrossWeight))}
          {this.renderFieldRowIfExists(fiMap, row, "TDRunDistance")}
          <div className="row fs15">
            <div className="column col-md-6">
              <span className="field-title">{fiMap["ReqPlanBeginLoadTime"].Title}</span>
              <span>&nbsp;{formatMnDate(row["ReqPlanBeginLoadTime"])}</span>
            </div>
            <div className="column col-md-6">
              <span className="field-title">{fiMap["PlanBeginLoadTime"].Title}</span>
              <span>&nbsp;{formatMnDate(row["PlanBeginLoadTime"])}</span>
            </div>
          </div>
          {this.renderFieldRowIfExists(fiMap, row, "TDManualPriceEdit")}
          {this.renderFieldRowIfExists(fiMap, row, "TDPlanCost")}
          {this.renderFieldRow(fiMap, row, "InterCompanyName")}
          {this.renderFieldRow(fiMap, row, "AutoDriver")}
          {row.Subject != null && this.renderFieldRow(fiMap, row, "Subject")}
        </>
      );
    }

    return null;
  };

  renderAcceptDurationTimer = () => {

    if(!this.props.row || !this.props.row.AcceptDurationSec || this.props.row.AcceptDurationSec < 0)
      return null;

    let acceptDuration = parseInt(this.props.row.AcceptDurationSec, 10);

    if(!acceptDuration || acceptDuration < 0)
      return null;

    let currentAcceptDuration = acceptDuration - this.state.elapsedAfterTimerUpdate;

    if(currentAcceptDuration <= 0)
      return null;

    //let seconds = currentAcceptDuration % 60;
    currentAcceptDuration = Math.floor(currentAcceptDuration / 60);
    let minutes = currentAcceptDuration % 60;
    currentAcceptDuration = Math.floor(currentAcceptDuration / 60);
    let hours = currentAcceptDuration;

    return(
      <div style={{ display: 'inline-block' }}>
        <span>
          <span >{this.zeroPad(hours, 2)}:{this.zeroPad(minutes, 2)}</span>
        </span>
      </div>
    );
  };

  zeroPad = (num, places) => {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
  };

  render() {

    let row = this.props.row;
    let docNumber = row.PickupListNumber;
    let docDate = formatMnDate(row.PickupListDate);
    let rowExpanded = this.state.isExpanded;
    let subGridExpanded = this.state.subGridExpanded;
    let expandButtonClass = rowExpanded ? "zmdi zmdi-chevron-up" : "zmdi zmdi-chevron-down";
    let expandSubgridButtonClass = subGridExpanded ? "zmdi zmdi-chevron-up" : "zmdi zmdi-chevron-down";

    let fiMap = {};

    this.props.dataItem.rawData.ResultFieldInfo.forEach((item) => {
      fiMap[item.Name] = item;
    });

    /*
    <div style={{ margin: "0 auto", marginRight: '0px', display: 'inline-block' }}>
                      <span className="zmdi zmdi-zoom-in" style={{ cursor: "pointer", color: "white", marginRight: "10px" }}
                            onClick={(e) => this.onShowRouteDetails(this.props.rowIndex)}/>
                      <span className={expandSubgridButtonClass} style={{ cursor: "pointer", color: "white" }}
                            onClick={(e) => this.onShowSubGrid(this.props.rowIndex)}/>
                    </div>
     */
    return (
      <React.Fragment>
        {this.renderRouteDetailsWindow()}
        {this.renderWaybillForm()}
        <div className="col-md-4" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
          <div className="col-md-12">
            <div className="card -cdoc mt10">
              <div className="card-header" style={{ paddingTop: "7px", paddingBottom: "7px" }}>
                <div className="row">
                  <div className="col-md-12"
                       style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', width: '100%' }}>
                    <h6 style={{ display: "inline-block", marginBottom: '0px' }}>
                      {i18next.t("TransportReqCard_CardTitle", { number: docNumber, date: docDate })}
                    </h6>
                    <div style={{ textAlign: 'center', display: 'inline-block', margin: '0 auto' }}>
                      <MnComboInlineEnum parentDataItem={this.props.dataItem} fieldInfo={fiMap["DistributionTypeId"]}
                                         rowIndex={this.props.rowIndex}
                                         readOnly
                      />
                    </div>
                    {this.renderAcceptDurationTimer()}
                    {row["IsYCQueueExists"] === 1 &&
                    <i className="zmdi zmdi-compass" style={{color: "green"}} title={i18next.t("OnTracking")} />
                    }
                    <DocumentStatusImage statusChar={row.CurrentStatus}
                                         style={{ marginLeft: '0', marginRight: "10px", display: "inline-block" }}/>
                    {this.props.showMode < 2 &&
                      <div style={{ display: 'inline-block' }}>
                          <span className={expandButtonClass}
                                onClick={(e) => this.onRowToggle(this.props.rowIndex)}
                                style={{ cursor: "pointer" }}/>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div className="card-body" style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <div className="row">
                  <div className="col-md-12" style={{
                    backgroundColor: "green",
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%'
                  }}>
                      <span style={{ color: "white" }}>{row.SrcCityName} > {row.DstCityName} {row.AutoTypeName} {row.RouteTypeName}</span>

                      <div style={{ margin: "0 auto", marginRight: '0px', display: 'inline-block' }}>
                        <span className="zmdi zmdi-zoom-in" style={{ cursor: "pointer", color: "white", marginRight: "10px", marginLeft: "5px", display: "inline" }}
                              onClick={(e) => this.onShowRouteDetails(this.props.rowIndex)}/>
                        <span className={expandSubgridButtonClass} style={{ cursor: "pointer", color: "white", margin: "0 auto", marginRight: '0px', display: 'inline-block' }}
                              onClick={(e) => this.onShowSubGrid(this.props.rowIndex)}/>
                      </div>

                  </div>
                </div>
                {subGridExpanded && this.renderRouteSubgrid(this.props.rowIndex)}
                {this.renderOptimalModeData(fiMap, row, this.props.rowIndex)}
                {this.renderAdditionalRowData(fiMap, row, this.props.rowIndex)}
                <div className="row fs15">
                  <div className="column col-md-11">
                    {this.renderCommandButtons(row, this.props.rowIndex)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TransportReqCard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  dataItem: PropTypes.object.isRequired,
  row: PropTypes.object.isRequired,
  rowIndex: PropTypes.number,
  routeSubGridColumnName: PropTypes.string,
  showMode: PropTypes.number, //0 - short, 1 - optimal, 2 - full
  onAcceptTransportReq: PropTypes.func,
  onRefuseTransportReq: PropTypes.func,
  onEditTransportReq: PropTypes.func,
  onSaveDataForCopy: PropTypes.func,
  onCreateTL: PropTypes.func,
  onGPSEdit: PropTypes.func,
  workplaceCountry: PropTypes.string,
  onCardDataChanged: PropTypes.func,
  getBufferData: PropTypes.func
};

TransportReqCard.defaultProps = {
};

function mapStateToProps(state, ownProps) {
  return {
    workplaceCountry: state.appState.appParams.workplaceCountry,
    routeDetailsItem: state.transportState.routeDetailsItem,
  };
}

export default connect(mapStateToProps)(TransportReqCard);